module.exports = __webpack_public_path__ + "img/resized-APP-0024-1.993f7cd5.png";